import { throwError } from 'rxjs';
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { ApiService } from "../../core/services/index";

@Injectable({
  providedIn: "root",
})
export class ConfigurationService {
  constructor(private _api: ApiService) {}

  getConfigByName(name: string) {
    return this._api.get(`config/name/${name}`).pipe(
      map((res: any) => res),
      catchError((error: any) => throwError(() => error))
    );
  }


}
